import { ButtonVariant, CoButton } from "components/CoButton";
import Dropdown, { CoDropdownItemProps } from "components/CoDropdown";
import useLabels from "hooks/useLabels";
import { PenLine, Trash2 } from "lucide-react";

interface BookmarkListItemActionButtonProps {
  onClickEditList: () => void;
  onClickDeleteList: () => void;
}

function BookmarkListItemActionButton({
  onClickEditList,
  onClickDeleteList,
}: BookmarkListItemActionButtonProps) {
  const [actionButtonLabels] = useLabels(
    "features.bookmark-lists.action-button"
  );

  const handleEditListClick = () => {
    if (onClickEditList) {
      onClickEditList();
    }
  };

  const handleDeleteListClick = () => {
    if (onClickDeleteList) {
      onClickDeleteList();
    }
  };

  const dropdownItems: CoDropdownItemProps[] = [
    {
      key: "edit-list",
      onClick: handleEditListClick,
      leftIcon: <PenLine size={20} />,
      title: actionButtonLabels["edit-list"],
    },
    {
      key: "copy-with-citation",
      onClick: handleDeleteListClick,
      leftIcon: <Trash2 size={20} />,
      title: actionButtonLabels["delete-list"],
      danger: true,
    },
  ];

  return (
    <Dropdown items={dropdownItems}>
      <CoButton
        variant={ButtonVariant.Flat}
        icon="icon-ellipsis-vertical"
        size="sm"
      />
    </Dropdown>
  );
}

export default BookmarkListItemActionButton;
